import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import graphQLError2Str from '../../utils/graphql-error-2-str';

const ErrorWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.white};
  color: ${props => props.theme.primaryColor};
  font-size: ${props => props.theme.fontBig};
`;

const Error = ({error}) => {
  console.log(error);
  return <ErrorWrapper>{graphQLError2Str(error)}</ErrorWrapper>;
};

Error.propTypes = {
  error: PropTypes.object,
};

export default Error;
